interface InlineAlertProps {
  tone?: "info" | "success" | "warning" | "danger";
  title: string;
  description?: string;
}

export function InlineAlert({ tone = "info", title, description }: InlineAlertProps): JSX.Element {
  const toneStyles: Record<NonNullable<InlineAlertProps["tone"]>, string> = {
    info: "bg-blue-50 text-blue-900 border-blue-200",
    success: "bg-green-50 text-green-900 border-green-200",
    warning: "bg-amber-50 text-amber-900 border-amber-200",
    danger: "bg-red-50 text-red-900 border-red-200",
  };

  return (
    <div className={`flex flex-col gap-1 rounded border px-3 py-2 text-sm ${toneStyles[tone]}`}>
      <div className="font-semibold">{title}</div>
      {description ? <div className="text-xs leading-relaxed">{description}</div> : null}
    </div>
  );
}
